import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditPersonalPage = {
  alert: {
    error: 'applicant-edit-personal-page.form.alert.error',
  },
  footer: {
    root: 'applicant-edit-personal-page.footer.root',
  },
  form: {
    cancelButton: 'applicant-edit-personal-page.form.cancel-button',
    emailAddressInput: 'applicant-edit-personal-page.form.email-address-input',
    emailAddressInputError:
      'applicant-edit-personal-page.form.email-address-input-error',
    firstNameInput: 'applicant-edit-personal-page.form.first-name-input',
    firstNameInputError:
      'applicant-edit-personal-page.form.first-name-input-error',
    h1: 'applicant-edit-personal-page.form.h1',
    h2: 'applicant-edit-personal-page.form.h2',
    lastNameInput: 'applicant-edit-personal-page.form.last-name-input',
    lastNameInputError:
      'applicant-edit-personal-page.form.last-name-input-error',
    phoneInputDisabled: 'applicant-edit-personal-page.form.phone-input',
    root: 'applicant-edit-personal-page.form.root',
    submitButton: 'applicant-edit-personal-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
